// TEZZO — hardcoded link data. Each category supports multiple accounts.
export const PROFILE = {
  name: "TEZZO",
  handle: "Tezzo100x",
  bio: "All my links in one place.",
  avatar:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_797be226-a249-48f3-9326-9617c2dc0719/artifacts/rvti3ilk_IMG_4443.jpg",
  banner:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_797be226-a249-48f3-9326-9617c2dc0719/artifacts/42qpbl7m_1500x500.jpeg",
};

export const FEATURED = {
  platform: "TWITCH",
  label: "FEATURED",
  handle: "tezzo100x",
  url: "https://www.twitch.tv/tezzo100x",
  note: "twitch.tv/tezzo100x",
};

export const DISCORD = {
  label: "COMMUNITY",
  handle: "Join the Discord",
  url: "https://discord.gg/2qYrFDqZk9",
  note: "discord.gg/2qYrFDqZk9",
};

// Each category holds platforms; each platform has an accounts[] array (supports multiples).
export const CHAPTERS = [
  {
    id: "01",
    title: "CRYPTO / CASINO",
    categories: [
      {
        platform: "YOUTUBE",
        accounts: [
          { handle: "tezzo100x", url: "https://www.youtube.com/@tezzo100x" },
        ],
      },
      {
        platform: "TIKTOK",
        accounts: [
          { handle: "tezzo100x", url: "https://www.tiktok.com/@tezzo100x" },
        ],
      },
      {
        platform: "INSTAGRAM",
        accounts: [
          { handle: "tezzo100x", url: "https://www.instagram.com/tezzo100x/" },
        ],
      },
      {
        platform: "X",
        accounts: [
          { handle: "Tezzo100x", url: "https://x.com/Tezzo100x" },
        ],
      },
    ],
  },
  {
    id: "02",
    title: "GAMING",
    categories: [
      {
        platform: "YOUTUBE",
        accounts: [
          { handle: "idktezzo", url: "https://www.youtube.com/@idktezzo" },
        ],
      },
      {
        platform: "INSTAGRAM",
        accounts: [
          { handle: "idktezzo", url: "https://www.instagram.com/idktezzo/" },
        ],
      },
      {
        platform: "X",
        accounts: [
          { handle: "idktezzo", url: "https://x.com/idktezzo" },
        ],
      },
      {
        platform: "TIKTOK",
        accounts: [
          { handle: "idk.tezzo", url: "https://www.tiktok.com/@idk.tezzo" },
        ],
      },
    ],
  },
];
